// Add your theme-wide JavaScript/TypeScript here.
import "./types";
import "./wishlist-store";
import "./header-group-dynamic-height";
import "./header-od-menu";
import "./header-od";
import "./collection-vehicle-filter";
import "./compare-toggle";
import "./wishlist-toggle";
import "./wishlist-counter";
import "./wishlist-products";
import "./compare-add-to-cart-event";
import "./active-vehicle-label";
import "./active-vehicle";

document.documentElement.classList.add("js");

console.info(
  "%cSoul+Wolf Overdrive Theme",
  "font-size: large; font-style: italic;",
);

export {};
